import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl';

require("../css/footer.scss");

class Footer extends React.Component{
  render() {
    return (
      <footer className="footer print-hidden">
        <div className="container">
          <p className="text-muted">
            <FormattedMessage
              id='footer.credit'
              description='Footer credit'
              defaultMessage='Created with {link}'
              values={{
                link: <a href="https://github.com/open-eats/OpenEats">OpenEats</a>
              }}
            />
            &nbsp;-&nbsp;
            <FormattedMessage
              id='footer.icon_credit'
              description='Footer icons credit'
              defaultMessage='Icons by {link}'
              values={{
                link: <a href="https://www.flaticon.com/authors/freepik" title="Freepik from www.flaticon.com">Freepik</a>
              }}
            />
          </p>
        </div>
      </footer>
    );
  }
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./modules/base/components/Footer.js